export default __webpack_public_path__ + "static/media/2.5f4f2a00.png";